import React, { Component } from 'react'
import { Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

class SFAssignmentCompletion extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Dialog fullWidth maxWidth="md" open={this.props.isCompleted} >
                {/* <DialogTitle>Assignment Complete</DialogTitle> */}
               {/*  <IconButton
                    aria-label="close"
                    // onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[900],
                    }}
                >
                    <CloseIcon />
                </IconButton> */}
                <DialogContent className='py-5'>
                    <div className='text-center py-5'>
                        <div style={{
                            fontSize: '8rem'
                        }}>🎉</div>
                        <Typography className='mb-3' fontWeight={800} fontSize={24} color={'primary'}>You Did It!</Typography>
                        <div className='d-flex justify-content-center'>
                            <Typography style={{width:"400px"}} fontSize={20} fontWeight={600}>
                                Congratulations {this.props.globalProperties.currentUserData.GivenName}, you are now a student Ninja!
                            </Typography>
                        </div>
                        <Typography className='fontClass-20 mt-4'>You can view your performance. And also set up optional additional practice. </Typography>
                        <Button variant='contained' className='mt-4'>View Performance Analysis</Button>
                    </div>
                    
                </DialogContent>

            </Dialog>
        )
    }
}

export default SFAssignmentCompletion;